import { Box, Flex, Space, Stack, Text } from "@mantine/core";
import { TStaffSurveyCase } from "../../../types";
import { SegmentedScale } from "../../../components/form/SegmentedScale";

type Props = {
  form: any;
  caso: TStaffSurveyCase;
  title: string;
};

const Component = ({ form, caso, title }: Props) => {
  const options = [
    "Totalmente de acuerdo.",
    "De acuerdo.",
    "En desacuerdo.",
    "Totalmente en desacuerdo.",
  ];

  const questions = [
    caso.case_resolution_statement,
    caso.normalization_statement,
    caso.victim_responsibility_statement,
    caso.exacerbated_intent_statement,
  ];

  const questionIds = [
    "CASE_AS_CASE_RESOLUTION",
    "CASE_AS_NORMALIZATION",
    "CASE_AS_VICTIM_RESPONSIBILITY",
    "CASE_AS_EXACERBATED_INTENT",
  ];

  // Combine questions with their corresponding IDs
  const questionsWithIds = questions.map((question, index) => ({
    question,
    id: questionIds[index],
  }));

  const handleScaleClick = (questionId: string, optionValue: string) => {
    form.setFieldValue(questionId, optionValue);
  };

  return (
    <Box px="sm">
      <Text size="lg">{title}</Text>
      <Space h="md" />

      <Stack spacing="md">
        {caso.description.split("\\n").map((paragraph, index) => (
          <Text key={index} size="sm" style={{ textAlign: "justify" }}>
            {paragraph}
          </Text>
        ))}
      </Stack>
      <Space h="md" />

      {/* Leyenda */}
      <Box
        p="md"
        bg="transparent"
        style={{
          borderRadius: 8,
          border: "1px solid #e9ecef",
        }}
        mb="xl"
      >
        <Text fw={400} mb="sm" color="gray.8">
          Leyenda
        </Text>
        <Flex wrap="wrap" gap="lg" justify="space-between">
          <Text size="sm" color="gray.7">
            <strong>1</strong> = Totalmente de acuerdo
          </Text>
          <Text size="sm" color="gray.7">
            <strong>2</strong> = De acuerdo
          </Text>
          <Text size="sm" color="gray.7">
            <strong>3</strong> = En desacuerdo
          </Text>
          <Text size="sm" color="gray.7">
            <strong>4</strong> = Totalmente en desacuerdo
          </Text>
        </Flex>
      </Box>

      <Stack spacing="xl">
        {questionsWithIds.map(({ question, id }) => (
          <Box key={id}>
            <Text size="sm" mb="md" style={{ textAlign: "justify" }}>
              {question}
            </Text>
            {form.errors[id] && (
              <Text fz="xs" color="red" mb="sm">
                *Debes seleccionar una opción.
              </Text>
            )}
            <SegmentedScale
              value={form.values[id] || ""}
              onChange={(value) => handleScaleClick(id, value)}
              segments={options}
            />
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default Component;
